import React, { FC } from 'react';
import styled from 'styled-components';
import { LoaderSpin, ModalContent, ModalHeader, ModalTitle, Text } from 'components';
import { toRem } from 'design';
import theme from 'design/theme';
import { IPOSProvider, ISiteIntegration } from 'types';
import { capitalize } from 'utils/strings';
import { Layout, StyledSubtitle, Wrapper } from '../styles';
import EmployeeInfo from './EmployeeInfo';

const LoaderLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: ${toRem(4)} 0;
  }
`;

const StyledLoaderSpin = styled(LoaderSpin)`
  margin-bottom: ${toRem(8)};
`;

interface ILoaderProps {
  dataCy: string;
  integration: ISiteIntegration;
  provider: IPOSProvider;
  onClose(): void;
}

const Loader: FC<ILoaderProps> = ({ provider, integration, onClose, dataCy }: ILoaderProps) => (
  <Layout isActive onClose={onClose} data-cy={`${dataCy}-loader`} maxWidth={540}>
    <ModalHeader>
      <ModalTitle data-cy="modal-title">Connect {capitalize(integration.type)} Employee To Kickfin</ModalTitle>
      <StyledSubtitle data-cy="modal-subtitle">Create a connection between employees on your POS to Kickfin users.</StyledSubtitle>
    </ModalHeader>
    <ModalContent>
      <Wrapper>
        <EmployeeInfo name={provider.name} type={provider.type} employeeId={provider.customerEmployeeId} dataCy={dataCy} />
        <LoaderLayout>
          <StyledLoaderSpin color={theme.color.secondary[400]} size={40} stroke={4} />
          <Text fontWeight="semibold">Please wait while we search for matching users...</Text>
        </LoaderLayout>
      </Wrapper>
    </ModalContent>
  </Layout>
);

export default Loader;
